module.exports = __webpack_public_path__ + "8d9e1e74e91147ea18b956311460984f.png";